import { render } from "./CategorysList.vue?vue&type=template&id=341e0dde"
import script from "./CategorysList.vue?vue&type=script&lang=js"
export * from "./CategorysList.vue?vue&type=script&lang=js"

import "./CategorysList.vue?vue&type=style&index=0&id=341e0dde&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__